export default "__VITE_ASSET___Ud7FWdE__"